
export const apiConstants = {
  url: "/api/weekProgram",
  events: "/api/event"
};
